import { render, staticRenderFns } from "./recovery.vue?vue&type=template&id=44a0a6d8"
import script from "./recovery.vue?vue&type=script&lang=js"
export * from "./recovery.vue?vue&type=script&lang=js"
import style0 from "./recovery.vue?vue&type=style&index=0&id=44a0a6d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports